import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3518617c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold -mb-[6px] z-20" }, "Checkpoints", -1))
const _hoisted_3 = { class: "w-full sticky top-0 bg-white py-4 z-10 flex items-center justify-center" }
const _hoisted_4 = { class: "w-full flex justify-start items-center bg-zewotherm-lightgrey h-12 rounded-lg" }
const _hoisted_5 = {
  key: 0,
  class: "font-bold text-white"
}
const _hoisted_6 = { class: "w-full flex flex-col justify-center" }
const _hoisted_7 = { class: "w-full h-auto flex flex-col gap-3" }

import Checkpoint from '@/interfaces/Checkpoint'
import { useCompany } from '@/store/company'
import { useSelectedProject } from '@/store/selectedProject'
import { Storage } from '@capacitor/storage'
import { alertController } from '@ionic/core'
import { computed } from '@vue/reactivity'
import axios from 'axios'
import { ComputedRef } from 'vue'
import { IonLabel, IonCheckbox } from '@ionic/vue';
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckpointComponent',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const companyStore = useCompany()
const currentUserStore = useCurrentUser()

async function toggleCheckpoint(checkpoint: Checkpoint) {
  const userData: any = (await Storage.get({ key: 'userData' })).value
  if(!userData) return
  
  try {
    await axios.post(process.env.VUE_APP_PROJECT_API_BASE_URL +'project/' + selectedProjectStore.project._id + '/checkpoint/' + checkpoint._id + '?company=' + companyStore.activeCompany.id, {
      updated_by: (JSON.parse(userData)).user.id,
      checked: !checkpoint.checked
    }, {
      headers: {
        Authorization: 'Bearer ' + currentUserStore.jwtKey
      }
    })

    const foundIndex = selectedProjectStore.project.checkpoints.findIndex(checkpointToFind => checkpointToFind._id === checkpoint._id)
    selectedProjectStore.project.checkpoints[foundIndex].checked = !selectedProjectStore.project.checkpoints[foundIndex].checked
  } catch (e) {
    console.error(e)
    const alert = await alertController.create({
      message: 'Konnte den Checkpoint nicht aktualisieren',
      buttons: ["OK"]
    })
    await alert.present()
  }
}

const checkpointPercent: ComputedRef<number> = computed(() => {
  let count = 0
    for(let i = 1; i <= selectedProjectStore.project.checkpoints.length; i++) {
      if(selectedProjectStore.project.checkpoints[i-1].checked) {
        count++
      }
    }
    return Math.round(100 / selectedProjectStore.project.checkpoints.length * count)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          style: _normalizeStyle('width: ' + _unref(checkpointPercent) + '%; background-color: ' + _unref(companyStore).activeCompany.color),
          class: "animationProgressBar h-full rounded-lg flex justify-center items-center"
        }, [
          (_unref(checkpointPercent) > 0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString(_unref(checkpointPercent)) + " %", 1))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedProjectStore).project.checkpoints, (checkpoint, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex justify-start items-center w-full"
          }, [
            _createVNode(_unref(IonCheckbox), {
              onClick: ($event: any) => (toggleCheckpoint(checkpoint)),
              style: _normalizeStyle('--background-checked: ' +	_unref(companyStore).activeCompany.color + '; --border-color-checked: ' +	_unref(companyStore).activeCompany.color),
              checked: checkpoint.checked,
              class: "h-7 w-7 flex-grow-0 min-w-7"
            }, null, 8, ["onClick", "style", "checked"]),
            _createVNode(_unref(IonLabel), { class: "ml-2 text-base md:text-lg h-full flex w-0 flex-grow items-center" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(checkpoint.name), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})